import { createFileRoute } from '@tanstack/react-router'
import EntityTypeBasicTab from '@admin/preferences/entities/EntityTypeBasicTab'
import { EntityTypeQueries } from '@admin/data'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useEntityTypeDetailValidContext } from '@admin/preferences/helper/EntityTypeDetailValidContext'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/')({
  component: RouteComponent,
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(EntityTypeQueries.entityTypes())
  },
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()
  const { data: entityTypeList } = useSuspenseQuery(EntityTypeQueries.entityTypes())

  const subEntities = useMemo(
    () => entityTypeList.filter((t) => t.requiresSubEntity && t.enabled),
    [entityTypeList],
  )

  const [, setValid] = useEntityTypeDetailValidContext()

  const handleDirty = (dirty: boolean) => {
    setValid(!dirty)
  }

  return (
    <EntityTypeBasicTab
      entityType={entityType}
      entities={entityTypeList}
      subEntities={subEntities}
      onDirty={handleDirty}
    />
  )
}
